"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _reactRouter = require("react-router");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _root;

  return {
    root: (_root = {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'flex-start',
      background: theme.palette.background.default,
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    }, (0, _defineProperty2.default)(_root, theme.breakpoints.down('sm'), {
      flexDirection: 'column'
    }), (0, _defineProperty2.default)(_root, "marginBottom", theme.spacing(2)), _root),
    fixedMenu: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    },
    item: (0, _defineProperty2.default)({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: 165,
      maxWidth: 'auto',
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
      height: 45,
      borderTopLeftRadius: 8,
      borderTopRightRadius: 8,
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
      background: 'linear-gradient(180deg, #FFF 67%, #FFF 50%, #E5E5E5 100%)',
      color: theme.palette.text.primary,
      border: '1px solid #BDBDBD',
      fontSize: 16,
      fontWeight: 400,
      textDecoration: 'none',
      textTransform: theme.text.textTransformUppercase,
      marginLeft: theme.spacing(1.5),
      '&:first-of-type': {
        marginLeft: 0
      }
    }, theme.breakpoints.down('sm'), {
      marginLeft: 0
    }),
    active: {
      background: 'linear-gradient(180deg, #C4C4C4 0%, #FFF 47%, #FFF 100%)',
      color: theme.palette.common.black,
      border: '1px solid #9E9E9E',
      borderBottom: 'none',
      height: theme.spacing(6.75)
    }
  };
}, {
  name: 'ProductDetailSpagettyNavigation'
});

var ProductDetailSpagettyNavigation = /*#__PURE__*/_react.default.forwardRef(function ProductDetailSpagettyNavigation(_ref, ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      fixedNavigation = _ref.fixedNavigation,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "fixedNavigation"]);
  var classes = useStyles({
    classes: pClasses
  });
  var location = (0, _reactRouter.useLocation)();
  var t = (0, _useTranslate.default)();
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: fixedNavigation ? (0, _clsx.default)(classes.root, className, classes.fixedMenu) : (0, _clsx.default)(classes.root, className),
    ref: ref
  }), /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _clsx.default)(classes.item, location.hash === '#description' && classes.active),
    href: '#description'
  }, t('productDetailSpagettyNavigation/description')), /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _clsx.default)(classes.item, location.hash === '#parameters' && classes.active),
    href: '#parameters'
  }, t('productDetailSpagettyNavigation/parameters')), /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _clsx.default)(classes.item, location.hash === '#package' && classes.active),
    href: '#package'
  }, t('productDetailSpagettyNavigation/package')), /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _clsx.default)(classes.item, location.hash === '#fotoAndVideo' && classes.active),
    href: '#fotoAndVideo'
  }, t('productDetailSpagettyNavigation/fotoAndVideo')), /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _clsx.default)(classes.item, location.hash === '#alternatives' && classes.active),
    href: '#alternatives'
  }, t('productDetailSpagettyNavigation/alternatives')), /*#__PURE__*/_react.default.createElement("a", {
    className: (0, _clsx.default)(classes.item, location.hash === '#questions' && classes.active),
    href: '#questions'
  }, t('productDetailSpagettyNavigation/questions')));
});

process.env.NODE_ENV !== "production" ? ProductDetailSpagettyNavigation.propTypes = {
  classes: _propTypes.default.shape({
    active: _propTypes.default.string,
    fixedMenu: _propTypes.default.string,
    item: _propTypes.default.string,
    root: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  fixedNavigation: _propTypes.default.bool
} : void 0;
ProductDetailSpagettyNavigation.defaultProps = {
  classes: undefined,
  className: undefined,
  fixedNavigation: false
};
var _default = ProductDetailSpagettyNavigation;
exports.default = _default;